export default __webpack_public_path__ + "static/media/background_lifestyle.7af31b1f.svg";